export const loadAnalytics = () => {
  // Check if scripts are already loaded to avoid duplicates
  // if (document.getElementById('clarity-script') || document.getElementById('rewardful-script')) {
  if (document.getElementById('clarity-script')) {
    return;
  }

  // Clarity initialization and script loading
  (window as any).clarity = (window as any).clarity || function () {
    ((window as any).clarity.q = (window as any).clarity.q || []).push(arguments);
  };

  const clarity = document.createElement('script');
  clarity.id = 'clarity-script';
  clarity.async = true;
  clarity.src = 'https://www.clarity.ms/tag/nh0y9q3jbn';
  const firstScript = document.getElementsByTagName('script')[0];
  if (firstScript && firstScript.parentNode) {
    firstScript.parentNode.insertBefore(clarity, firstScript);
  } else {
    document.head.appendChild(clarity);
  }

  // Rewardful initialization and script loading
  // (window as any)._rwq = 'rewardful';
  // (window as any).rewardful = (window as any).rewardful || function () {
  //   ((window as any).rewardful.q = (window as any).rewardful.q || []).push(arguments);
  // };

  // const rewardful = document.createElement('script');
  // rewardful.id = 'rewardful-script';
  // rewardful.async = true;
  // rewardful.src = 'https://r.wdfl.co/rw.js';
  // rewardful.setAttribute('data-rewardful', '632b0a');
  // document.body.appendChild(rewardful);
};
